import { Wrapper } from 'components/common/utils/wrapper/Wrapper';
// import { Padding } from 'lib/styles/Padding';
import React from 'react';
import { Card } from 'reactstrap';
import TableContent from './TableContent';

export default class ListView extends React.Component<{[label: string]: any} , {[label: string]: any}> {
    constructor(props) {
        super(props)
        this.state = {

        }
    }

    public render() {
        let index: number = 0; 
        return (
            <div>
                <p>
                    <br/>
                </p>
                <Card className="mb-2">
          
              
              <Wrapper>
              <div className="scrollable">
                <table className="w-100 table-responsive--base" style={{minWidth: '690px', fontSize: '15px'}}>      
                <thead>
                    <tr style={{height: '40px'}}>
                      <th style={{textAlign: 'center', width: '80px'}}><strong>Index</strong></th>
                      <th style={{width: '200px'}}><strong>Event</strong></th>
                      <th style={{width: '200px'}}><strong>Location</strong></th>
                      <th style={{width: '130px'}}><strong>Date</strong></th>
                      <th style={{textAlign: 'center', width: '130px'}}><strong>Tickets Sold</strong></th>
                      <th style={{textAlign: 'center', width: '130px'}}><strong>Total Revenue</strong></th>
                      <th style={{textAlign: 'center', width: '150px'}}><strong>Actions</strong></th>
                      
                    </tr>
                  </thead>
                  <tbody>


              {this.props.events && this.props.events.length > 0
                ? this.props.activeEvents.map((event: any) => {
                    switch (this.props.filter) {
                      case "active":
                        if (event.isActive === true) {
                            index += 1;
                          return (
                            <TableContent event={event} index={index}/>
                          );
                        }
                      
                      case "":
                        index += 1;
                        return (
                          <TableContent event={event} index={index}/>
                        );
                    }
                  })
                : <div>
                    <p>
                        <br/>
                        <br/>You have no events.
                    </p>
                </div>
              }
              
            
              {this.props.events && this.props.events.length > 0
                ? this.props.inactiveEvents.map((event: any) => {
                 switch (this.props.filter) {
                      case "finished":
                        if (event.isActive === false || event.isActive === null) {
                            index += 1;
                            return (
                              <TableContent event={event} index={index}/>
                            ); 
                        }
                        break;
                      case "":
                        index += 1;
                        return (
                          <TableContent event={event} index={index}/>
                        );    
                    }
                  })
                : null }
                </tbody>
                </table>
                </div>
                </Wrapper>           
            </Card>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/manage/events/manage/ListView.tsx